import { render, staticRenderFns } from "./AttachmentsManager.vue?vue&type=template&id=b6c50400&scoped=true"
import script from "./AttachmentsManager.vue?vue&type=script&lang=js"
export * from "./AttachmentsManager.vue?vue&type=script&lang=js"
import style0 from "./AttachmentsManager.vue?vue&type=style&index=0&id=b6c50400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c50400",
  null
  
)

export default component.exports